import { Field, Menu } from "@omnabase/ui";
import { OFF, accessName, assignableRoles, type RoleDef } from "@omnabase/shared";

/** One access rule as a select: Default (and what that currently is), a named role, or no access (ported). */
export function RuleSelect({ label, roles, rule, defaultLabel, disabled, onChange }: { label: string; roles: RoleDef[]; rule: string | undefined; defaultLabel: string; disabled?: boolean; onChange: (rule: string | null) => void }) {
  return (
    <Menu align="end" trigger={<Field label={label} value={rule ? accessName(roles, rule) : defaultLabel} disabled={disabled} />} sections={[
      { items: [{ id: "default", label: defaultLabel, checked: !rule, onSelect: () => onChange(null) }] },
      { label: "Role", items: assignableRoles(roles).map((r) => ({ id: r.id, label: r.name, checked: rule === r.id, onSelect: () => onChange(r.id) })) },
      { items: [{ id: OFF, label: "No access", checked: rule === OFF, onSelect: () => onChange(OFF) }] },
    ]} />
  );
}
